import * as React from 'react'

import { Box, Tag } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const RestDayCell = () => {
  return (
    <Box flexDirection="row">
      <Tag type={Tag.Types.fuchsia}>
        {i18n.t('shift_management.templates.weeks.settings_rest_day')}
      </Tag>
    </Box>
  )
}

export default RestDayCell
